import { motion } from 'motion/react';

interface RodapeEventoProps {
  totalRotulo?: string;
  totalValor?: string | null;
  /** Linha pequena embaixo do preço (ex.: "+ R$ 2,40 de taxa"). */
  valorNota?: string | null;
  botaoTexto: string;
  botaoIcone?: string;
  onBotao: () => void;
  desabilitado?: boolean;
  cor?: 'primary' | 'success';
}

const CORES = {
  primary: 'bg-primary-500 hover:bg-primary-600 shadow-pbtn',
  success: 'bg-success-500 hover:bg-success-600',
};

// Rodapé fixo do evento: Total à esquerda + botão principal (56 px) à direita.
export default function RodapeEvento({
  totalRotulo = 'Total',
  totalValor,
  valorNota = null,
  botaoTexto,
  botaoIcone,
  onBotao,
  desabilitado = false,
  cor = 'primary',
}: RodapeEventoProps) {
  return (
    <motion.div
      initial={{ y: '100%' }}
      animate={{ y: 0 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 backdrop-blur-md"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="mx-auto flex w-full max-w-[720px] items-center gap-4 px-5 py-3">
        {totalValor && (
          <div className="min-w-0">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-foreground-400">
              {totalRotulo}
            </p>
            <p className="truncate text-[20px] font-extrabold leading-tight text-foreground-950">
              {totalValor}
            </p>
            {valorNota && (
              <p className="truncate text-[11px] font-semibold text-foreground-500">{valorNota}</p>
            )}
          </div>
        )}

        <button
          type="button"
          onClick={onBotao}
          disabled={desabilitado}
          className={`aperta ml-auto inline-flex h-14 shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[18px] px-6 text-[15px] font-bold text-white transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${CORES[cor]}`}
        >
          {botaoIcone && (
            <span className="flex h-5 w-5 items-center justify-center">
              <i className={botaoIcone} aria-hidden />
            </span>
          )}
          {botaoTexto}
        </button>
      </div>
    </motion.div>
  );
}